import { Divider, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import ErrorMessage from "../../utils/ErrorMessage";
import { getItem, profileDataValidation, validateName } from "../../utils/Functions";
import regexUtils from "../../utils/regexUtils";
import SelectDropdown from "../SelectDropdown/SelectDropdown";
import PencilCursor from "../../assets/images/pencil-cursor.svg";
import {
  ProfileCancelButton,
  ProfileEditButton,
  ProfileSaveButton,
} from "./ProfileButtons";
import { useDispatch, useSelector } from "react-redux";
import { preferenceListing } from "../../pages/Profile/actions";
import PhoneInput from "react-phone-input-2";
const BasicInfo = ({
  basicInfo,
  showInput,
  handleShowInput,
  handleUpdate,
  basicinfo,
  setBasicInfo,
  errors,
  setErrors,
  isGuest,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.profile.loading);
  const preferenceReduxData = useSelector(
    (state) => state.profile.preferenceDetailedList
  );
  const [workPreferenceOption, setWorkPreferenceOption] = useState([]);
  useEffect(() => {
    if (preferenceReduxData?.data && preferenceReduxData?.data?.length > 0) {
      const list = [];
      preferenceReduxData?.data?.map((item) => {
        return list.push({
          label: item?.workPreference,
          value: item?._id,
        });
      });
      setWorkPreferenceOption(list);
    } else {
      setWorkPreferenceOption([]);
    }
  }, [preferenceReduxData]);
  const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
  ];

  const noticePeriodOptions = [
    { label: "Immediately", value: "Immediately" },
    { label: "15 Days", value: "15 Days" },
    { label: "30 Days", value: "30 Days" },
    { label: "45 Days", value: "45 Days" },
    { label: "60 Days", value: "60 Days" },
    { label: "90 Days", value: "90 Days" },
    { label: "More Than 90 Days", value: "More Than 90 Days" },
  ];

  useEffect(() => {
    dispatch(preferenceListing());
  }, []);

  useEffect(() => {
    if (!isGuest) {
      setBasicInfo({
        ...basicInfo,
        jobLocation: {
          label: basicInfo?.jobLocation?.workPreference,
          value: basicInfo?.jobLocation?._id,
        },
      });
    } else {
      // Guest email is the login account email (disabled); keep it in sync
      const guestEmail =
        basicInfo?.emailId ||
        basicInfo?.email ||
        basicInfo?.basicInfo?.email ||
        (() => {
          try {
            const user = JSON.parse(getItem("User") || "{}");
            return user?.emailId || user?.email || getItem("emailId") || "";
          } catch {
            return getItem("emailId") || "";
          }
        })();

      if (guestEmail) {
        setBasicInfo((prev) =>
          prev.email === guestEmail ? prev : { ...prev, email: guestEmail }
        );
      }
    }
  }, [basicInfo, isGuest]);

  const handleChange = async (phoneNumber, country, name, dialCode) => {
    const reducedPhone = phoneNumber.replace(country.dialCode, "");
    setBasicInfo({
      ...basicinfo,
      [name]: reducedPhone,
      [dialCode]: country.dialCode,
    });
  };

  return (
    <>
      <div className={`panel-header ${isGuest ? "sec-head" : ""}`} id="section-basic-info">
        {isGuest && <div className="sec-num">1</div>}
        <div className="title">Basic Info</div>
      </div>
      <div className="panel-content py-0">
        <Row>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-firstName">
                <label className="form-label">
                  First Name<span className="text-danger">*</span>
                </label>

                {!isGuest && !showInput.firstName && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(basicInfo?.firstName)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("firstName");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.firstName) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={basicinfo?.firstName}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length > 0 && inputValue[0] === " ") {
                          return;
                        }
                        setBasicInfo({ ...basicinfo, firstName: inputValue });
                        if (inputValue === "") {
                          setErrors({
                            ...errors,
                            firstName: ErrorMessage.PROVIDE_FIRST_NAME,
                          });
                        } else if (!validateName(inputValue)) {
                          setErrors({
                            ...errors,
                            firstName: ErrorMessage.PROVIDE_VALID_FIRST_NAME,
                          });
                        } else {
                          setErrors({ ...errors, firstName: "" });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!basicinfo.firstName.trim()) {
                              setErrors({
                                ...errors,
                                firstName: ErrorMessage.PROVIDE_FIRST_NAME,
                              });
                            } else {
                              setErrors({ ...errors, firstName: "" });
                              handleUpdate("firstName", basicinfo.firstName);
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("firstName");
                            setBasicInfo({
                              ...basicinfo,
                              firstName: basicInfo.firstName,
                            });
                            setErrors({ ...errors, firstName: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.firstName}</span>
              </div>
            )}
          </Col>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-lastName">
                <label className="form-label">
                  Last Name<span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.lastName && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(basicInfo?.lastName)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("lastName");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.lastName) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={basicinfo?.lastName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length > 0 && value[0] === " ") {
                          return;
                        }
                        setBasicInfo({ ...basicinfo, lastName: value });
                        if (value === "") {
                          setErrors({
                            ...errors,
                            lastName: ErrorMessage.PROVIDE_LAST_NAME,
                          });
                        } else if (!validateName(value)) {
                          setErrors({
                            ...errors,
                            lastName: ErrorMessage.PROVIDE_VALID_LAST_NAME,
                          });
                        } else {
                          setErrors({
                            ...errors,
                            lastName: "",
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!basicinfo.lastName.trim()) {
                              setErrors({
                                ...errors,
                                lastName: ErrorMessage.PROVIDE_LAST_NAME,
                              });
                            } else {
                              setErrors({ ...errors, lastName: "" });
                              handleUpdate("lastName", basicinfo.lastName);
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("lastName");
                            setBasicInfo({
                              ...basicinfo,
                              lastName: basicInfo.lastName,
                            });
                            setErrors({ ...errors, lastName: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.lastName}</span>
              </div>
            )}
          </Col>

          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group">
                <label className="form-label">
                  Email{isGuest && <span className="text-danger">*</span>}
                </label>
                {!isGuest && !showInput.emailId && (
                  <div className="">
                    <h6 className="mt-1 text-title cursor-pencil form-control bg-gray">
                      {profileDataValidation(basicInfo?.email)}
                    </h6>
                    {/* <ProfileEditButton
                      onClick={() => {
                        handleShowInput("emailId");
                      }}
                    /> */}
                  </div>
                )}
                {(isGuest || showInput.emailId) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={basicinfo?.email}
                      disabled={true}
                      onChange={(e) => {
                        if (e.target.value !== "") {
                          setBasicInfo({ ...basicinfo, email: e.target.value });
                          setErrors({ ...errors, email: "" });
                        } else {
                          setBasicInfo({ ...basicinfo, email: e.target.value });
                          setErrors({
                            ...errors,
                            email: ErrorMessage.PROVIDE_EMAIL,
                          });
                        }
                      }}
                    />
                    {/* {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!basicinfo.email.trim()) {
                              setErrors({
                                ...errors,
                                email: ErrorMessage.PROVIDE_EMAIL,
                              });
                            } else if (
                              !new RegExp(regexUtils.emailCandidateRegex).test(
                                basicinfo.email
                              )
                            ) {
                              setErrors({
                                ...errors,
                                email: ErrorMessage.PROVIDE_VALID_EMAIL,
                              });
                            } else {
                              setErrors({ ...errors, email: "" });
                              handleUpdate("emailId", basicinfo.email);
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("emailId");
                            setBasicInfo({
                              ...basicinfo,
                              email: basicInfo.email,
                            });
                            setErrors({ ...errors, email: "" });
                          }}
                        />
                      </>
                    )} */}
                  </div>
                )}
                <span className="text-error">{errors.email}</span>
              </div>
            )}
          </Col>
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Secondary Email</label>
                  {!isGuest && !showInput.secondaryEmail && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(basicInfo?.secondaryEmail)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("secondaryEmail");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.secondaryEmail) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={basicinfo?.secondaryEmail}
                        onChange={(e) => {
                          setBasicInfo({
                            ...basicinfo,
                            secondaryEmail: e.target.value,
                          });
                          setErrors({ ...errors, secondaryEmail: "" });
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              if (
                                basicinfo.secondaryEmail.trim() &&
                                !new RegExp(
                                  regexUtils.emailCandidateRegex
                                ).test(basicinfo.secondaryEmail)
                              ) {
                                setErrors({
                                  ...errors,
                                  secondaryEmail:
                                    ErrorMessage.PROVIDE_VALID_SECONDARY_EMAIL,
                                });
                              } else {
                                setErrors({ ...errors, secondaryEmail: "" });
                                handleUpdate(
                                  "secondaryEmail",
                                  basicinfo.secondaryEmail
                                );
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("secondaryEmail");
                              setBasicInfo({
                                ...basicinfo,
                                secondaryEmail: basicInfo.secondaryEmail,
                              });
                              setErrors({ ...errors, secondaryEmail: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">{errors.secondaryEmail}</span>
                </div>
              )}
            </Col>
          )}

          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-mobile">
                <label className="form-label">
                  Mobile<span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.mobile && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(
                        basicInfo?.phoneCode
                          ? `+${basicInfo?.phoneCode + basicInfo?.mobile}`
                          : basicInfo?.mobile
                      )}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("mobile");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.mobile) && (
                  <div className="edit-inline-action">
                    <PhoneInput
                      country={"in"}
                      countryCodeEditable={false}
                      enableSearch
                      autoFormat={false}
                      maxLength={16}
                      disableSearchIcon={true}
                      className={
                        errors.mobile !== "" ? "form-control error-red" : ""
                      }
                      value={
                        basicinfo?.phoneCode
                          ? basicinfo?.phoneCode + basicinfo?.mobile
                          : basicinfo?.mobile
                      }
                      onChange={(phoneNumber, country) => {
                        handleChange(
                          phoneNumber,
                          country,
                          "mobile",
                          "phoneCode"
                        );
                        setErrors({ ...errors, mobile: "" });
                      }}
                    />
                    {/* 
                <Form.Control
                  type="text"
                  value={basicinfo?.mobile}
                  onWheel={(e) => e.target.blur()}
                  maxLength="13"
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-", "."].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/[^0-9]/gi, "");
                    if (value !== "") {
                      setBasicInfo({
                        ...basicinfo,
                        mobile: value,
                      });
                      setErrors({ ...errors, mobile: "" });
                    } else {
                      setBasicInfo({
                        ...basicinfo,
                        mobile: value,
                      });
                      setErrors({
                        ...errors,
                        mobile: ErrorMessage.PROVIDE_MOBILE,
                      });
                    }
                  }}
                /> */}
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!basicinfo.mobile.trim()) {
                              setErrors({
                                ...errors,
                                mobile: ErrorMessage.PROVIDE_MOBILE,
                              });
                            } else if (
                              !new RegExp(regexUtils.mobileRegex).test(
                                basicinfo.mobile
                              )
                            ) {
                              setErrors({
                                ...errors,
                                mobile: ErrorMessage.PROVIDE_VALID_MOBILE,
                              });
                            } else {
                              setErrors({ ...errors, mobile: "" });
                              handleUpdate("mobile", basicinfo.mobile);
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("mobile");
                            setBasicInfo({
                              ...basicinfo,
                              mobile: basicInfo.mobile,
                              phoneCode: basicInfo.phoneCode,
                            });
                            setErrors({ ...errors, mobile: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.mobile}</span>
              </div>
            )}
          </Col>
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Phone</label>
                  {!isGuest && !showInput.phone && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(basicInfo?.phone)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("phone");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.phone) && (
                    <div className="edit-inline-action">
                      {/* <PhoneInput
                        country={"in"}
                        countryCodeEditable={false}
                        enableSearch
                        autoFormat={false}
                        maxLength={16}
                        disableSearchIcon={true}
                        className={
                          errors.phone !== "" ? "form-control error-red" : ""
                        }
                        value={
                          basicinfo?.mobileCode
                            ? basicinfo?.mobileCode + basicinfo?.phone
                            : basicinfo?.phone
                        }
                        onChange={(phoneNumber, country) => {
                          handleChange(
                            phoneNumber,
                            country,
                            "phone",
                            "mobileCode"
                          );
                          setErrors({ ...errors, phone: "" });
                        }}
                      /> */}

                      <Form.Control
                        type="text"
                        value={basicinfo?.phone}
                        onWheel={(e) => e.target.blur()}
                        maxLength="11"
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-", "."].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^0-9]/gi, "");
                          setBasicInfo({
                            ...basicinfo,
                            phone: value,
                          });
                          setErrors({ ...errors, phone: "" });
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              if (
                                basicinfo.phone.trim() &&
                                !new RegExp(regexUtils.phoneRegex).test(
                                  basicinfo.phone
                                )
                              ) {
                                setErrors({
                                  ...errors,
                                  phone: ErrorMessage.PROVIDE_VALID_PHONE,
                                });
                              } else {
                                setErrors({ ...errors, phone: "" });
                                handleUpdate("phone", basicinfo.phone);
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("phone");
                              setBasicInfo({
                                ...basicinfo,
                                phone: basicInfo.phone,
                              });
                              setErrors({ ...errors, phone: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">{errors.phone}</span>
                </div>
              )}
            </Col>
          )}

          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Gender</label>
                  {/* <span className="mandatory-mark">*</span> */}
                  {!isGuest && !showInput.gender && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(basicInfo?.gender)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("gender");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.gender) && (
                    <div className="edit-inline-action">
                      <SelectDropdown
                        placeholder="Select gender"
                        options={genderOptions}
                        defaultValue={{
                          label: basicInfo?.gender,
                          value: basicInfo?.gender,
                        }}
                        cancelKeyboardEventOnSelection={true}
                        tether={false}
                        onValueChange={(e) => {
                          if (e === undefined) {
                            setBasicInfo({
                              ...basicinfo,
                              gender: "",
                            });
                          } else {
                            setBasicInfo({
                              ...basicinfo,
                              gender: e?.value,
                            });
                            setErrors({
                              ...errors,
                              gender: "",
                            });
                          }
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              if (!basicinfo.gender) {
                                setErrors({
                                  ...errors,
                                  gender: ErrorMessage.PROVIDE_GENDER,
                                });
                              } else {
                                setErrors({
                                  ...errors,
                                  gender: "",
                                });
                                handleUpdate("gender", basicinfo.gender);
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("gender");
                              setBasicInfo({
                                ...basicinfo,
                                gender: basicInfo.gender,
                              });
                              setErrors({ ...errors, gender: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">{errors.gender}</span>
                </div>
              )}
            </Col>
          )}
          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Work Preference</label>
                  {/* <span className="mandatory-mark">*</span> */}
                  {!isGuest && !showInput.jobLocation && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(
                          basicInfo?.jobLocation?.workPreference
                        )}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("jobLocation");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.jobLocation) && (
                    <div className="edit-inline-action">
                      <SelectDropdown
                        placeholder="Select Job Location"
                        options={workPreferenceOption}
                        defaultValue={{
                          label: basicInfo?.jobLocation?.workPreference,
                          value: basicInfo?.jobLocation?._id,
                        }}
                        onValueChange={(e) => {
                          if (e === undefined) {
                            setBasicInfo({
                              ...basicinfo,
                              jobLocation: "",
                            });
                          } else {
                            setBasicInfo({
                              ...basicinfo,
                              jobLocation: e,
                            });
                            setErrors({
                              ...errors,
                              jobLocation: "",
                            });
                          }
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() => {
                              if (!basicinfo.jobLocation.value) {
                                setErrors({
                                  ...errors,
                                  jobLocation:
                                    ErrorMessage.PROVIDE_WORK_PREFRENCE,
                                });
                              } else {
                                setErrors({
                                  ...errors,
                                  jobLocation: "",
                                });
                                handleUpdate(
                                  "jobLocation",
                                  basicinfo.jobLocation.value
                                );
                              }
                            }}
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("jobLocation");
                              setBasicInfo({
                                ...basicinfo,
                                jobLocation: {
                                  label: basicInfo?.jobLocation,
                                  value: basicInfo?.jobLocation?._id,
                                },
                              });
                              setErrors({ ...errors, jobLocation: "" });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  <span className="text-error">{errors.jobLocation}</span>
                </div>
              )}
            </Col>
          )}

          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-noticePeriod">
                <label className="form-label">
                  Notice Period <span className="text-danger">*</span>
                </label>
                {!isGuest && !showInput.noticePeriod && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(basicInfo?.noticePeriod)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("noticePeriod");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.noticePeriod) && (
                  <div className="edit-inline-action">
                    <SelectDropdown
                      placeholder="Select Notice Period"
                      options={noticePeriodOptions}
                      defaultValue={{
                        label: basicInfo?.noticePeriod,
                        value: basicInfo?.noticePeriod,
                      }}
                      isSearch={false}
                      onValueChange={(e) => {
                        if (e === undefined) {
                          setBasicInfo({
                            ...basicinfo,
                            noticePeriod: "",
                          });
                        } else {
                          setBasicInfo({
                            ...basicinfo,
                            noticePeriod: e?.value,
                          });
                          setErrors({
                            ...errors,
                            noticePeriod: "",
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!basicinfo.noticePeriod) {
                              setErrors({
                                ...errors,
                                noticePeriod:
                                  ErrorMessage.PROVIDE_NOTICE_PERIOD,
                              });
                            } else {
                              setErrors({
                                ...errors,
                                noticePeriod: "",
                              });
                              handleUpdate(
                                "noticePeriod",
                                basicinfo.noticePeriod
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("noticePeriod");
                            setBasicInfo({
                              ...basicinfo,
                              noticePeriod: basicInfo.noticePeriod,
                            });
                            setErrors({ ...errors, noticePeriod: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.noticePeriod}</span>
              </div>
            )}
          </Col>

          {!isGuest && (
            <Col md={4} sm={6}>
              {loading && <Skeleton active paragraph={{ rows: 2 }} />}
              {!loading && (
                <div className="form-group">
                  <label className="form-label">Current Location</label>
                  {!isGuest && !showInput.currentLocation && (
                    <div className="edit-profile-input">
                      <h6 className="mt-1 text-title cursor-pencil">
                        {profileDataValidation(basicInfo?.currentLocation)}
                      </h6>
                      <ProfileEditButton
                        onClick={() => {
                          handleShowInput("currentLocation");
                        }}
                      />
                    </div>
                  )}
                  {(isGuest || showInput.currentLocation) && (
                    <div className="edit-inline-action">
                      <Form.Control
                        type="text"
                        value={basicinfo?.currentLocation}
                        onChange={(e) => {
                          setBasicInfo({
                            ...basicinfo,
                            currentLocation: e.target.value,
                          });
                        }}
                      />
                      {!isGuest && (
                        <>
                          <ProfileSaveButton
                            onClick={() =>
                              handleUpdate(
                                "currentLocation",
                                basicinfo.currentLocation
                              )
                            }
                          />
                          <ProfileCancelButton
                            onClick={() => {
                              handleShowInput("currentLocation");
                              setBasicInfo({
                                ...basicinfo,
                                currentLocation: basicInfo.currentLocation,
                              });
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </Col>
          )}
        </Row>
      </div>
    </>
  );
};

export default BasicInfo;
